import React, { useEffect, useState } from 'react';
import * as ReactDOM from 'react-dom';
import moment from 'moment';
import { NavLink } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { Icons, Row } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import {
  dateFormatter, infoFormatterIntl, infoFormatter, localeFormatter, vehiclesStatusFormatter, federalFawFormatter,
} from '../../../utils/formatters';
import { getRegisterData } from '../reducer';
import RecipientView from './RecipientView';
import Loader from '../../../components/base/Loader/Loader';
import SZLTMiniGrid from './SZLTMiniGrid';
import CarrierMiniGrid from './CarrierMiniGrid';
import InsuranceView from '../../Application/components/ViewBlocks/InsuranceView';
import {
  APPLICATION_STATUS, REGION_REGISTRY_RELATION,
} from '../../../configs';
import DocumentList from '../../Application/components/DocumentList';
import { RegistryRelationHistoryDialog } from './RegistryRelationHistoryDialog';
import RegistryPageModal from './RegistryPageModal';
import ApplicationLegend from '../../Application/components/ApplicationLegend';
import AccordionWithPreview from '../../../components/base/Accordion/AccordionWithPreview';

export default function VehiclesView(props) {
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const {
    onClose = () => {}, handleEdit = () => {}, loadData = () => {}, formMeta,
  } = props;
  const [isHistoryPopUp, setIsHistoryPopUp] = useState(false);
  const [isSameRegistryPopUp, setIsSameRegistryPopUp] = useState(false);

  const {
    currentVehicles = {},
    loadingCheckAllVehicles,
  } = useSelector(getRegisterData);

  const { order_services = [], carrier, documents = [] } = currentVehicles;
  const carriers = [];
  if (carrier && carrier.id) {
    carriers.push(carrier);
  }

  return ReactDOM.createPortal(
    <div className="application-form">
      <Loader loading={loadingCheckAllVehicles} />
      <div className="application-form-header">
        <div className="breadcrumbs">
          <span className="breadcrumbs-prev">Реестры</span>
          <Icons width={22} height={22} customIcon icon="arrow-right" className="breadcrumbs-arrow" />
          <span className="breadcrumbs-prev">Реестр ЛТ</span>
          <Icons width={22} height={22} customIcon icon="arrow-right" className="breadcrumbs-arrow" />
          <span className="breadcrumbs-prev">Запись ЛТ</span>
          <Icons width={22} height={22} customIcon icon="arrow-right" className="breadcrumbs-arrow" />
          <span
            className="breadcrumbs-current"
          >Запись ЛТ № {currentVehicles?.number || 'Без номера'} (просмотр)
          </span>
        </div>
        <div className="legend-button">
          <Icons width={24} height={24} customIcon icon="helper" />
          <ApplicationLegend />
        </div>
        <div className="close-button" onClick={onClose}>
          <Icons width={24} height={24} customIcon icon="close" />
        </div>
      </div>
      <div className="application-form-body application-form-view szlt-registry">
        <div className="application-form-body-wrapper">
          <div className="application-form-content">
            <div className="application-form-fields">
              <div className="application-form-fields-wrapper custom-scroll-theme">
                <div className="afc-header">
                  Запись ЛТ №{currentVehicles.number}
                  {vehiclesStatusFormatter(currentVehicles.status)}
                  {federalFawFormatter(currentVehicles?.federal_law_number)}
                  <div className="afc-header-link">
                    <div className="afc-header-link-same">
                      <Icons
                        customIcon
                        icon="same-registry"
                        onClick={() => setIsSameRegistryPopUp(true)}
                      />
                    </div>
                    <NavLink
                      to={{
                        pathname: '/application',
                        search: new URLSearchParams({
                          filter: 'carrier',
                          status: Object.values(APPLICATION_STATUS),
                          number: currentVehicles.number,
                          created_at: [moment(currentVehicles.created_at).subtract(1, 'year').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
                        }).toString(),
                      }}
                      target="_blank"
                    >
                      <Icons
                        customIcon
                        icon="show-relation-link"
                      />
                    </NavLink>
                  </div>
                </div>
                <div className="afc-body">
                  <div className="afc-main">
                    <Row className="row-cols-2">
                      {infoFormatterIntl('registry.number', currentVehicles.number, formMeta, 'number')}
                      {infoFormatterIntl('created_at', dateFormatter(currentVehicles.created_at), formMeta, 'created_at')}
                    </Row>
                    <Row className="row-cols-2">
                      {infoFormatterIntl('effective_date', dateFormatter(currentVehicles.effective_date), formMeta, 'effective_date')}
                      {infoFormatterIntl('expiration_date', dateFormatter(currentVehicles.expiration_date), formMeta, 'expiration_date')}
                    </Row>
                    {
                      [APPLICATION_STATUS.SUSPENDED].includes(currentVehicles.status) ? (
                        <Row className="row-cols-3">
                          {infoFormatter('Основание', currentVehicles.rejection_reason_messages?.[0]?.name || '')}
                          {infoFormatter('Дополнительное основание', currentVehicles?.rejection_reason_messages?.[0]?.additional_message || '')}
                          {infoFormatter('Комментарий', currentVehicles.rejection_reason_messages?.[0]?.message || '')}
                        </Row>
                      ) : null
                      }
                    <RecipientView current={currentVehicles} isVehicle formMeta={formMeta} />
                    <div className="hr-row" />
                    <div className="f4">Информация о транспортном средстве</div>
                    <Row className="row-cols-3">
                      {infoFormatterIntl('vehicle_brand', currentVehicles.vehicle_brand, formMeta, 'vehicle_brand')}
                      {infoFormatterIntl('vehicle_model', currentVehicles.vehicle_model, formMeta, 'vehicle_model')}
                      {infoFormatterIntl('vehicle_year', currentVehicles.vehicle_year, formMeta, 'vehicle_year')}
                    </Row>
                    <Row className="row-cols-3">
                      {infoFormatterIntl('vehicle_color', currentVehicles.vehicle_color, formMeta, 'vehicle_color')}
                      {infoFormatterIntl('vehicle_lpn', currentVehicles.vehicle_lpn, formMeta, 'vehicle_lpn')}
                      {infoFormatterIntl('vehicle_vin', currentVehicles.vehicle_vin, formMeta, 'vehicle_vin')}
                    </Row>
                    <Row className="row-cols-2">
                      {infoFormatterIntl('vehicle_registration_number', currentVehicles.vehicle_registration_number, formMeta, 'vehicle_registration_number')}
                      {infoFormatterIntl('vehicle_registration_issue_date', dateFormatter(currentVehicles.vehicle_registration_issue_date), formMeta, 'vehicle_registration_issue_date')}
                    </Row>
                    <Row className="row-cols-2">
                      {infoFormatterIntl('has_special_lifting_device', currentVehicles.has_special_lifting_device ? 'Есть' : 'Нет', formMeta, 'has_special_lifting_device')}
                      {infoFormatterIntl('ecology_class', localeFormatter('ecology-class', currentVehicles.ecology_class), formMeta, 'ecology_class')}
                    </Row>
                    <div className="hr-row" />
                    <div className="f4">Дополнительная информация</div>
                    <InsuranceView data={currentVehicles} formMeta={formMeta} />
                    <Row className="row-cols-1">
                      {infoFormatterIntl('technical_control_address', currentVehicles.technical_control_address, formMeta, 'technical_control_address')}
                    </Row>
                    <Row className="row-cols-2">
                      {infoFormatterIntl('decision', currentVehicles.decision, formMeta, 'decision')}
                      {infoFormatterIntl('decision_date', dateFormatter(currentVehicles.decision_date), formMeta, 'decision_date')}
                    </Row>
                    <Row className="row-cols-2">
                      {infoFormatterIntl('ownership_type', formatMessage({ id: `ownership.type.${currentVehicles.ownership_type}` }), formMeta, 'ownership_type')}
                      {infoFormatterIntl('ownership_contract_number', currentVehicles.ownership_contract_number, formMeta, 'ownership_contract_number')}
                    </Row>
                    <Row className="row-cols-2">
                      {infoFormatterIntl('ownership_contract_effective_date', dateFormatter(currentVehicles.ownership_contract_effective_date), formMeta, 'ownership_contract_effective_date')}
                      {infoFormatterIntl('ownership_contract_expiration_date', dateFormatter(currentVehicles.ownership_contract_expiration_date), formMeta, 'ownership_contract_expiration_date')}
                    </Row>
                    <div className="hr-row" />
                    <AccordionWithPreview
                      title="Документы"
                      content={(
                        <DocumentList
                          id={currentVehicles?.id}
                          loadData={loadData}
                        />
                      )}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="application-form-content afc-right">
            <CarrierMiniGrid
              params={{
                vehicle_id: currentVehicles.id,
              }}
              setIsHistoryPopUp={setIsHistoryPopUp}
            />
            <SZLTMiniGrid
              params={{
                vehicle_id: currentVehicles.id,
              }}
              setIsHistoryPopUp={setIsHistoryPopUp}
              isCarrierRelationType={false}
            />
          </div>
          {isHistoryPopUp ? (
            <RegistryRelationHistoryDialog
              currentCarrier={currentVehicles}
              subject_type="vehicle"
              subject_id={currentVehicles?.id}
              log_name={isHistoryPopUp === 'szlt' ? REGION_REGISTRY_RELATION.VEHICLE_ORDER_SERVICE : REGION_REGISTRY_RELATION.VEHICLE_CARRIER}
              onClose={() => setIsHistoryPopUp(false)}
            />
          ) : null}
          {isSameRegistryPopUp
            ? (
              <RegistryPageModal
                type="vehicle"
                onClose={() => setIsSameRegistryPopUp(false)}
                customFilter={{
                  vehicle_vin: currentVehicles?.vehicle_vin,
                }}
                title="Реестровые записи в отношении данного ЛТ"
                filterName="vehicle-same-list-modal-filter"
              />
            ) : null}
        </div>
      </div>
    </div>,
    document.getElementById('app-content'),
  );
}
